import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'

import { STACK_N_LOAD } from '~/statistics/constants'
import { StackNLoadProductAPIStat } from '~/statistics/types/stack-n-load.types'

import ProductCardContainer from '../ProductCardContainer'

import StackNLoadSummary from './StackNLoadSummary'
import StackNLoadDetails from './StackNLoadDetails'

interface Props {
  product: StackNLoadProductAPIStat
}

export default function StackNLoadProductCard({ product }: Props): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName: STACK_N_LOAD, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <StackNLoadSummary onClick={onToogle} showContent={showContent} timeSpent={product.timeSpent} />
      {showContent && <StackNLoadDetails product={product} />}
    </ProductCardContainer>
  )
}
